import { render, staticRenderFns } from "./ShortAnswerContainer.vue?vue&type=template&id=3fc1e76c&scoped=true&"
import script from "./ShortAnswerContainer.vue?vue&type=script&lang=js&"
export * from "./ShortAnswerContainer.vue?vue&type=script&lang=js&"
import style0 from "./ShortAnswerContainer.vue?vue&type=style&index=0&id=3fc1e76c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc1e76c",
  null
  
)

export default component.exports